import React from 'react';
import { Box, Button, Text } from '@wix/design-system';
import { StatusDeniedFilled } from '@wix/wix-ui-icons-common';
export const DisplayError = _ref => {
  let {
    message,
    cta
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "8px",
    border: "1px solid red",
    borderRadius: "12px",
    borderColor: "B40",
    padding: "SP2",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "4px"
  }, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "top"
  }, /*#__PURE__*/React.createElement(StatusDeniedFilled, {
    color: "#FF6666"
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, message))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "right",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    target: "_blank",
    onClick: () => window.open(cta.url, '_blank')
  }, cta.title)));
};
export const DisplayError1 = _ref2 => {
  let {
    message,
    cta
  } = _ref2;
  return /*#__PURE__*/React.createElement(Box, {
    gap: "4px",
    direction: "horizontal",
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StatusDeniedFilled, {
    color: "#FF6666"
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, message || 'Something went wrong.')), cta && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: () => window.open(cta == null ? void 0 : cta.url, '_blank')
  }, cta.title)));
};
//# sourceMappingURL=DisplayError.js.map